/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to parse api validation errors to wizard params
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { IWizardValidationError } from '../wizardTypes';

interface IValidationMapApiToParams {
    [key: string]: string;
}

interface IValidationResult {
    [key: string]: string;
}

export function parseWizardValidationErrors(validationErrors: IWizardValidationError[],
                                            validationParamsMap: IValidationMapApiToParams) {
    return validationErrors.reduce((errors: IValidationResult, error: IWizardValidationError) => {
        if (Object.keys(validationParamsMap).includes(error.field)) {
            errors[validationParamsMap[error.field]] =
                error.code;
        }
        return errors;
    }, {});
}
